import { clamp } from "./clampRotation";

/**
 * Normalize a client pointer into -1…1 relative to a rect (or viewport).
 */
export function normalizePointer(clientX, clientY, rect) {
  const w = rect?.width ?? (typeof window !== "undefined" ? window.innerWidth : 1);
  const h = rect?.height ?? (typeof window !== "undefined" ? window.innerHeight : 1);
  const left = rect?.left ?? 0;
  const top = rect?.top ?? 0;
  const x = ((clientX - left) / w) * 2 - 1;
  const y = -(((clientY - top) / h) * 2 - 1);
  return {
    x: clamp(x, -1, 1),
    y: clamp(y, -1, 1),
  };
}

/** Apply deadzone so tiny noise doesn't drive animation */
export function applyDeadzone(value, deadzone = 0.02) {
  if (Math.abs(value) < deadzone) return 0;
  const sign = value < 0 ? -1 : 1;
  return sign * ((Math.abs(value) - deadzone) / (1 - deadzone));
}

/**
 * Map normalized pointer to CSS parallax pixel offsets (existing Hero bg behavior).
 */
export function pointerToCssParallax(clientX, clientY, strength = 24) {
  const x = (clientX / window.innerWidth - 0.5) * strength;
  const y = (clientY / window.innerHeight - 0.5) * strength;
  return { x, y };
}
